import React from 'react';
import { PropTypes } from 'prop-types';
import { menuBlockResize } from '../Common/Helper';

const NavItemDesktopDynamicImage = props => (
  <a href={props.tRoute(props.headerHref)}>
    <div className='mmd__column-image lazyload'
      data-bg={props.menuSubitems[0].imageUrl}
      style={{height: `${menuBlockResize(props.height, props.rowSize)}`}}>
    </div>
  </a>
);

NavItemDesktopDynamicImage.propTypes = {
  headerHref: PropTypes.string,
  menuSubitems: PropTypes.arrayOf(PropTypes.shape({
    imageUrl: PropTypes.string,
  })),
};

export default NavItemDesktopDynamicImage;



// WEBPACK FOOTER //
// ./src/Nav/NavItemDesktopDynamicImage.js